import React from 'react';
import styled from 'styled-components';
import { imageUrlFor } from "../lib/image-url";

function Image(props) {
  const {image} = props;
  return <ImageElement src={imageUrlFor(image).url()} alt={image.alt} />;
}

export default Image;

const ImageElement = styled.img`
    display: flex;
    width: 100%;
    border-radius: 10px;
`;
